import { motion } from "framer-motion";
import { ClipboardCheck, Search, MessageSquare } from "lucide-react";

const steps = [
  { icon: ClipboardCheck, title: "We review your current setup" },
  { icon: Search, title: "We identify gaps in your funnel" },
  { icon: MessageSquare, title: "We walk you through a clear improvement plan" },
];

export const WhatHappensNext = () => {
  return (
    <div>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-2xl md:text-3xl font-bold mb-6 text-foreground"
      >
        What Happens Next?
      </motion.h2>
      <div className="space-y-4 mb-6">
        {steps.map((step, i) => (
          <motion.div
            key={step.title}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className="flex items-center gap-4"
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary font-bold text-sm shrink-0">
              {i + 1}
            </div>
            <span className="text-foreground font-medium">{step.title}</span>
          </motion.div>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.4 }}
        className="text-sm text-muted-foreground italic"
      >
        This is a no-pressure conversation focused on helping you improve your results.
      </motion.p>
    </div>
  );
};
